<template lang="html">
  <div id="scroll-target" style="max-height: 100vh" :class="['overflow-y-auto frame-sidebar', { 'active': isActive }]">
    <div class="sheet-bar">
      <div class="sheet-bar-content">
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="d-flex align-center">
                <v-spacer />
                <v-btn icon class="mr-2" @click="isActive = false">
                  <v-icon color="#272727">
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <div class="sidebar-wrap">
      <template v-if="notSystem && !$isEmpty(customer)">
        <div class="sidebar-image pt-4">
          <img :src="customer.avatar_img_path" :alt="customer.avatar_name">
        </div>
        <div class="text-center my-4">
          <div class="font-18 font-weight-700 name-sidebar-menu">
            {{ customer.name }}
          </div>
          <router-link :to="{ name: '_change_profile' }" class="font-14 font-weight-700 ol-brand text-direction-none">
            {{ $t('v2.change_profile') }}
          </router-link>
        </div>
        <div class="px-4 mb-4">
          <div class="container-drawer-item-nav">
            <div class="drawer-item-nav cursor-pointer" @click="goToLoyaltyPoint()">
              <div class="drawer-item-box">
                <div class="flex-image">
                  <div class="mr-2 align-self-start">
                    <img src="@/assets/images/v2/img/icon_point.png" alt="Voucher" class="image-16">
                  </div>
                  <div class="flex-image-content">
                    <div class="flex-image-content-text ol-grey-content font-11">
                      {{ $t('v2.loyalty_points') }}
                    </div>
                    <div class="flex-image-content-text font-14 font-weight-600">
                      {{ Number(customer.join_loyalty_points) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="drawer-item-nav">
              <div class="drawer-item-box">
                <div class="flex-image">
                  <div class="mr-2 align-self-start">
                    <img src="@/assets/images/v2/img/icon_transaction.png" alt="Voucher" class="image-16">
                  </div>
                  <div class="flex-image-content">
                    <div class="flex-image-content-text ol-grey-content font-11">
                      {{ $t('v2.transactions') }}
                    </div>
                    <div class="flex-image-content-text font-14 font-weight-600">
                      {{ Number(customer.transaction) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="list-link mb-4">
          <div class="px-4 mb-4">
            <outlet-selection v-model="store_id" :params="params_outlet" @select-outlet="selectOutlet" />
          </div>
          <router-link :to="{ name: '_orders' }" class="list-link-item flex-image">
            <div class="flex-image-avatar mr-4">
              <v-icon>
                mdi-format-list-bulleted
              </v-icon>
            </div>
            <div class="flex-image-content">
              <div class="flex-image-content-text font-14 font-weight-600 ol-black line-height-normal">
                {{ $t('v2.your_orders') }}
              </div>
            </div>
          </router-link>
          <div class="list-link-item flex-image cursor-pointer" @click="showPopupLogout()">
            <div class="flex-image-avatar mr-4">
              <v-icon color="olreddark" class="mirror">
                mdi-logout
              </v-icon>
            </div>
            <div class="flex-image-content">
              <div class="flex-image-content-text font-14 font-weight-600 olreddark--text line-height-normal">
                {{ $t('v2.logout') }}
              </div>
            </div>
          </div>
        </div>
        <div class="px-2">
          <div class="div-line my-2" />
        </div>
      </template>
      <template v-else-if="(!notSystem || $isEmpty(customer)) && $store.state.selected_type === 'DINE-IN'">
        <div class="sidebar-image pt-4">
          <img :src="$store.state.selected_outlet.logo" :alt="$store.state.selected_outlet.name">
        </div>
        <div class="text-center mt-4 font-18 font-weight-700">
          {{ $store.state.selected_outlet.name }}
        </div>
        <div v-if="$store.state.selected_type === 'DINE-IN'" class="d-flex justify-center mt-2">
          <div class="wrap-table">
            <div class="wrap-table-icon">
              <img :src="icon_table" :alt="$t('table')">
            </div>
            <div class="wrap-table-content">
              <div class="wrap-table-text">
                {{ $t('table') }} {{ noTable }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="!notSystem || $isEmpty(customer)">
        <div class="list-link mb-4">
          <!-- <router-link :to="{ name: '_orders' }" class="list-link-item flex-image">
            <div class="flex-image-avatar mr-4">
              <v-icon>
                mdi-format-list-bulleted
              </v-icon>
            </div>
            <div class="flex-image-content">
              <div class="flex-image-content-text font-14 font-weight-600 ol-black line-height-normal">
                {{ $t('v2.your_orders') }}
              </div>
            </div>
          </router-link> -->
          <div class="px-4 mb-4">
            <outlet-selection v-model="store_id" :params="params_outlet" @select-outlet="selectOutlet" />
          </div>
          <div class="list-link-item flex-image cursor-pointer" @click="goToLogin()">
            <div class="flex-image-avatar mr-4">
              <v-icon>
                mdi-login
              </v-icon>
            </div>
            <div class="flex-image-content">
              <div class="flex-image-content-text font-14 font-weight-600 line-height-normal">
                {{ $t('v2.login') }}
              </div>
            </div>
          </div>
        </div>
        <div class="px-2">
          <div class="div-line my-2" />
        </div>
      </template>
      <template v-if="$store.state.selected_type !== 'DINE-IN'">
        <div class="list-menu">
          <div class="title-list-menu list-menu-item">
            {{ $t('v2.other_services') }}
          </div>
          <div v-if="selectedOutlet.setting && !$isEmpty(selectedOutlet.setting) && selectedOutlet.setting.use_takeaway === 1 && $store.state.selected_type !== 'OL-TAKE-AWAY'" class="d-flex list-menu-item list-menu-link" @click="selectService('OL-TAKE-AWAY')">
            <div class="list-menu-item-image">
              <img src="@/assets/images/v2/img/icon-side-takeaway.png" :alt="$t('v2.takeaway')">
            </div>
            <div class="list-menu-item-content">
              <div class="list-menu-item-title">
                {{ $t('v2.takeaway') }}
              </div>
            </div>
          </div>
          <div v-if="selectedOutlet.setting && !$isEmpty(selectedOutlet.setting) && selectedOutlet.setting.use_delivery === 1 && $store.state.selected_type !== 'DELIVERY'" class="d-flex list-menu-item list-menu-link" @click="selectService('DELIVERY')">
            <div class="list-menu-item-image">
              <img src="@/assets/images/v2/img/icon-side-delivery.png" :alt="$t('v2.delivery')">
            </div>
            <div class="list-menu-item-content">
              <div class="list-menu-item-title">
                {{ $t('v2.delivery') }}
              </div>
            </div>
          </div>
          <div v-if="selectedOutlet.setting && !$isEmpty(selectedOutlet.setting) && selectedOutlet.setting.use_reservation === 1 && $store.state.selected_type !== 'RESERVATION'" class="d-flex list-menu-item list-menu-link" @click="selectService('RESERVATION')">
            <div class="list-menu-item-image">
              <img src="@/assets/images/v2/img/icon-side-reservation.png" :alt="$t('v2.food_reservation')">
            </div>
            <div class="list-menu-item-content">
              <div class="list-menu-item-title">
                {{ $t('v2.food_reservation') }}
              </div>
            </div>
          </div>
          <div v-if="selectedOutlet.setting && !$isEmpty(selectedOutlet.setting) && selectedOutlet.setting.use_place_reservation === 1 && $store.state.selected_type !== 'TABLE_RESERVATION'" class="d-flex list-menu-item list-menu-link" @click="selectService('TABLE_RESERVATION')">
            <div class="list-menu-item-image">
              <img src="@/assets/images/v2/img/icon-side-reservation-table.png" :alt="$t('v2.table_reservation')">
            </div>
            <div class="list-menu-item-content">
              <div class="list-menu-item-title">
                {{ $t('v2.table_reservation') }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <div v-if="listMenu.length > 0" v-scroll:#scroll-target="onScroll" class="sidebar-menu mt-4">
        <div class="list-menu">
          <div class="title-list-menu list-menu-item">
            {{ $t('v2.catogory') }}
          </div>
          <div v-if="hasCombo" :class="[`list-menu-item list-menu-link`, { 'item-menu-active': sidebarActive[0] === true }]" @click="goToCombo()">
            {{ $t('v2.combo') }}
          </div>
          <div v-for="(item_menu, i) in listMenu" :key="i" :class="[`list-menu-item list-menu-link`, , { 'item-menu-active': hasCombo ? sidebarActive[i + 1] === true : sidebarActive[i] === true }]" @click="goToGroup(item_menu.id)">
            {{ item_menu.name }}
          </div>
        </div>
        <!-- {{ listMenu }} -->
      </div>
    </div>
    <v-dialog v-model="dialog.logout" max-width="350">
      <v-card class="br-10">
        <div class="pa-4">
          <div class="text-center font-18 font-weight-700 mb-4">
            {{ $t('v2.are_u_sure_to_logout') }}
          </div>
          <div class="card-action-button">
            <div class="card-action-item-button">
              <v-btn block color="white" height="40" class="text-none font-weight-700 ol-black letter-spacing-normal ol-elevation-1 br-5" @click="dialog.logout = false">
                {{ $t('v2.cancel2') }}
              </v-btn>
            </div>
            <div class="card-action-item-button">
              <v-btn block color="white" height="40" class="text-none font-weight-700 ol-red letter-spacing-normal ol-elevation-1 br-5" @click="logout()">
                {{ $t('v2.yes_logout') }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.confirm" max-width="350">
      <v-card class="br-10">
        <div class="pa-4">
          <div class="text-center font-18 font-weight-700 mb-2">
            {{ $t('v2.move_to_outlet', { outlet: temp_outlet.name }) }}
          </div>
          <div class="font-14 mb-4 font-weight-400 ol-black text-center line-height-normal">
            {{ $t('v2.selected_menu_from_previous') }}
          </div>
          <div class="card-action-button">
            <div class="card-action-item-button">
              <v-btn block color="white" height="40" class="text-none font-weight-700 ol-black letter-spacing-normal ol-elevation-1 br-5" @click="dialog.confirm = false">
                {{ $t('v2.cancel3') }}
              </v-btn>
            </div>
            <div class="card-action-item-button">
              <v-btn block color="olbrand" height="40" class="text-none font-weight-700 white--text letter-spacing-normal ol-elevation-1 br-5" @click="changeStore()">
                {{ $t('v2.yes_next') }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <alert v-model="alert.show" :message="alert.message" />
  </div>
</template>
<script>
import Alert from '@/components/v2/Alert'
import OutletSelection from '@/components/v2/OutletSelection'
import { mapGetters } from 'vuex'
import {
  getData as getCustomer
} from '@/api/customer'
import {
  logout as logoutCustomer
} from '@/api/auth'
export default {
  name: 'SidebarMenu',
  components: {
    Alert,
    OutletSelection
  },
  props: {
    value: {
      default: false,
      type: Boolean
    },
    listMenu: {
      default: () => [],
      type: Array
    },
    clickMenu: {
      required: true,
      type: Function
    },
    scrollMenu: {
      required: true,
      type: Function
    },
    sidebarActive: {
      type: Array,
      required: true
    },
    hasCombo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      detail_table: {},
      alert: {
        show: false,
        message: ''
      },
      dialog: {
        logout: false,
        confirm: false
      },
      customer: {},
      icon_table: require('@/assets/images/v2/img/icon_table.png'),
      cart: {},
      allow_location: false,
      store_id: {
        id: null,
        url: ''
      },
      params_outlet: {
        origin_lat: 0,
        origin_lon: 0
      },
      previousService: '',
      previousStoreId: '',
      temp_outlet: {}
    }
  },
  computed: {
    ...mapGetters(['notSystem']),
    noTable() {
      if (!this.$isEmpty(this.detail_table) && !this.$isEmpty(this.detail_table.table_detail) && this.detail_table.table_detail.name) {
        return this.detail_table.table_detail.name
      } else {
        return ''
      }
    },
    'isActive': {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    selectedOutlet() {
      return this.$store.state.selected_outlet
    }
  },
  watch: {
    isActive(newItem) {
      if (newItem === true) {
        document.querySelector('html').style.overflowY = 'hidden'
        if (this.notSystem) {
          this.getDataCustomer()
        }
      } else {
        document.querySelector('html').style.overflowY = 'scroll'
      }
    }
  },
  beforeDestroy() {
    document.querySelector('html').style.overflowY = 'scroll'
  },
  mounted() {
    this.store_id.id = this.$store.state.selected_outlet.id
    this.store_id.url = this.$store.state.selected_outlet.url_id
    const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
    if (LOCAL_DATA_CART) {
      this.cart = JSON.parse(LOCAL_DATA_CART)
    }
    const DETAIL_TABLE = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_table')
    if (DETAIL_TABLE) {
      this.detail_table = JSON.parse(DETAIL_TABLE)
    }
    const PREVIOUS_SERVICE = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_type')
    if (PREVIOUS_SERVICE) {
      this.previousService = JSON.parse(PREVIOUS_SERVICE)
    }
    const PREVIOUS_STORE_ID = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_id')
    if (PREVIOUS_STORE_ID) {
      this.previousStoreId = Number(PREVIOUS_STORE_ID)
    }
    this.checkPermission()
  },
  methods: {
    goToLogin() {
      this.$router.push({ name: '_phone_check', query: { redirect: this.$route.name }}).catch(() => {})
    },
    goToLoyaltyPoint() {
      this.$router.push({ name: '_loyalty_point' }).catch(() => {})
    },
    async goToCombo() {
      this.isActive = await false
      await this.clickMenu()
    },
    async goToGroup(id) {
      this.isActive = await false
      await this.clickMenu('product', id)
    },
    async getDataCustomer() {
      try {
        const { data } = await getCustomer()
        this.customer = data.data
      } catch (e) {
        this.customer = {}
        console.log(e)
      }
    },
    showPopupLogout() {
      this.dialog.logout = true
    },
    async logout() {
      try {
        await logoutCustomer()
        this.$store.dispatch('fetchToken')
        this.alert.show = true
        this.alert.message = this.$t('v2.logged_out_successfully')
        // this.$router.push({ name: '_menu' }).catch(() => {})
        this.isActive = false
        if (typeof this.cart.redeemId !== 'undefined' || typeof this.cart.requestId !== 'undefined' || typeof this.cart.point_detail !== 'undefined') {
          this.$delete(this.cart, 'requestId')
          this.$delete(this.cart, 'redeemId')
          this.$delete(this.cart, 'point_detail')
          await this.$store.dispatch('saveCartV2', this.cart)
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
      this.dialog.logout = false
      this.isActive = false
    },
    async onScroll(e) {
      await this.scrollMenu(e)
    },
    async checkPermission() {
      if (navigator.geolocation) {
        await navigator.geolocation.getCurrentPosition(this.successPosition, this.failurePosition, {
          enableHighAccuracy: true,
          timeout: 5000
        })
      } else {
        alert(`Browser doesn't support Geolocation`)
      }
    },
    successPosition: async function(position) {
      this.allow_location = true
      this.params_outlet.origin_lat = position.coords.latitude
      this.params_outlet.origin_lon = position.coords.longitude
    },
    failurePosition() {
      this.allow_location = false
      console.log('failure')
    },
    async selectService(remark) {
      this.isActive = await false
      this.$store.dispatch('saveSelectedType', remark)
    },
    selectOutlet(item) {
      this.temp_outlet = item
      this.dialog.confirm = true
    },
    async changeStore() {
      let cart = {
        item: []
      }
      if (this.previousStoreId === Number(this.store_id.id)) {
        cart = { ...this.cart }
      } else if (this.previousStoreId === Number(this.store_id.id)) {
        if (typeof this.cart.item === 'undefined' || this.$isEmpty(this.cart.item)) {
          cart.item = []
        } else {
          cart.item = this.cart.item
        }
      }
      const obj = {
        url_id: this.temp_outlet.url_id,
        id: Number(this.temp_outlet.id)
      }
      this.store_id = obj
      this.$store.dispatch('saveCartV2', cart)
      await this.$store.dispatch('fetchOutlet', obj)
      await this.$store.dispatch('saveSelectedId', Number(this.temp_outlet.id))
      this.dialog.confirm = false
      this.isActive = false
      this.$emit('triggerLoadProduct', true)
    }
  }
}
</script>
